export default {
	title: "Личный Центр",
	subTitle: ["Профиль", "Безопасность", "Система"],
	menu: ["Изменить личную информацию", "Имя пользователя", "Обновить пароль", "Обновить пароль для транзакций"],
	updatePassword: {
		form: {
			label: ["Старый пароль", "Новый пароль", "Подтвердите новый пароль"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Старый пароль", "Новый пароль", "Подтвердите новый пароль"]
		}
	}
};
